import { Injectable } from '@angular/core';
import { UrlTree, DefaultUrlSerializer } from "@angular/router";

@Injectable()
export class LowerCaseUrlSerializerService extends DefaultUrlSerializer {


  parse(url: string): UrlTree {
    
        if (url.toLowerCase().indexOf("authenticateuser") > -1 || url.toLowerCase().indexOf("activateuser") > -1) {
            return super.parse( url);
        }
        else
            return super.parse(url.toLowerCase());
    }

}
